import React, {Component} from 'react';
import FontAwesome from 'react-fontawesome';
import './stage.css';

export default class ScrollButton extends Component {
  constructor(props) {
    super(props);
    this.state = {active: false}
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }
  componentWillMount() {
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('keyup', this.handleKeyUp);
  }
  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('keyup', this.handleKeyUp);
    window.clearInterval(this.interval);
  }
  handleMouseEnter() {
    window.clearInterval(this.interval);
    this.interval = window.setInterval(this.props.scroll, 10);
    this.setState({active: true});
  }
  handleMouseLeave() {
    window.clearInterval(this.interval);
    this.setState({active: false});
  }
  handleKeyDown(event) {
    if(event.key.toLowerCase() === `arrow${this.props.direction}`) {
      event.preventDefault();
      window.clearInterval(this.interval);
      this.interval = window.setInterval(this.props.scroll, 10);
      this.setState({active: true});
    }
  }
  handleKeyUp(event) {
    if(event.key.toLowerCase() === `arrow${this.props.direction}`) {
      event.preventDefault();
      window.clearInterval(this.interval);
      this.setState({active: false});
    }
  }
  render() {
    return (
      <div className={`scroll-button scroll-button-${this.props.direction}`} onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
        <FontAwesome name={`arrow-${this.props.direction}`} size={this.state.active ? '3x' : '2x'} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/stage/scroll-button.js